import { SYSTEM_PARAMS_ACTIONS } from 'constants/Actions/SystemParams';

// Estado inicial del reducer
const aInitialState = {
    aParams: [],
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los parámetros del sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const SystemParamsReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case SYSTEM_PARAMS_ACTIONS.GET:
            return { ...aState, aParams: oAction.data };
        default:
            return aState;
    }
}
